import {Langdict} from './langdict';

export class ITokenType {
  description?: Langdict;
  tokenTypeId: string;
  count?: number;
  price?: number;
  isActive?: boolean;
}

export class TokenType extends  ITokenType {
  constructor(obj: ITokenType) {
    super();
    this.description = new Langdict(obj.description);
    this.tokenTypeId = obj.tokenTypeId;
    this.count = obj.count;
    this.price = obj.price;
    this.isActive = obj.isActive;
  }
}
